// extracted by mini-css-extract-plugin
export default {"root":"Worm__root--qiCcB","root_new_portal_header":"Worm__root_new_portal_header--Ydw7n","btn":"Worm__btn--31B7Z","btn_new":"Worm__btn_new--38xoZ"};